import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

type OrderID = string;

interface CurrentTicketMovingContextType {
  currentTicketMoving: OrderID[];
  setCurrentTicketMoving: React.Dispatch<React.SetStateAction<OrderID[]>>;
  clearCurrentTicketMoving: () => void;
}

const CurrentTicketMovingContext = createContext<CurrentTicketMovingContextType | undefined>(undefined);

export const CurrentTicketMovingProvider = ({ children }: { children: ReactNode }) => {
  const [currentTicketMoving, setCurrentTicketMoving] = useState<OrderID[]>([]);

  const clearCurrentTicketMoving = () => {
    setCurrentTicketMoving([]);
  };

  // ESC để clear
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        clearCurrentTicketMoving();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <CurrentTicketMovingContext.Provider value={{ currentTicketMoving, setCurrentTicketMoving, clearCurrentTicketMoving }}>
      {children}
    </CurrentTicketMovingContext.Provider>
  );
};

export const useCurrentTicketMoving = () => {
  const ctx = useContext(CurrentTicketMovingContext);
  if (!ctx) throw new Error('useCurrentTicketMoving must be used inside CurrentTicketMovingProvider');
  return ctx;
};

